import { render, staticRenderFns } from "./HousesModule.vue?vue&type=template&id=665c732a&scoped=true&"
import script from "./HousesModule.vue?vue&type=script&lang=js&"
export * from "./HousesModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665c732a",
  null
  
)

export default component.exports